"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsSubscriptionSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
exports.OperationsSubscriptionSchema = {
    name: 'operations-subscription',
    alias: 'Operations Subscription',
    shortName: 'Subscription',
    applications: ['aap', 'customer-portal', 'wayste'],
    disabled: false,
    returnType: {
        aap: transport_types_1.Operations.Subscription,
        wayste: transport_types_1.Operations.Subscription,
        // 'customer-portal': Operations.Subscription,
    },
    searchableAttributes: [
        {
            field: 'orders.serviceLocation.address.addressLine1',
            alias: 'Service Location Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'orders.serviceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'orders.serviceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'orders.serviceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'orders.serviceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'orders.serviceLocation.address.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
        {
            field: 'orders.serviceLocation.name',
            alias: 'Service Location Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customer.displayName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'customer.companyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'customer.customerNumber',
            alias: 'Customer Number',
            shortName: 'Customer Number',
            searchableByDefault: false,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'number',
            alias: 'Subscription Number',
            shortName: 'Subscription Number',
            searchableByDefault: true,
            boost: 1.5,
        },
        {
            field: 'poNumber',
            alias: 'PO Number',
            shortName: 'PO Number',
            searchableByDefault: true,
        },
        {
            field: 'orders.commercialOrder.description',
            alias: 'Commercial Order Description',
            shortName: 'Commercial Order Description',
            searchableByDefault: true,
        },
        {
            field: 'orders.commercialOrder.vendorName',
            alias: 'Vendor Name',
            shortName: 'Vendor',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
    ],
    filterableAttributes: [
        {
            field: 'startTimestamp',
            alias: 'Start Date',
            shortName: 'Start Date',
            type: 'TIMESTAMP',
            allowedOperators: 'ALL',
            format: 'ISO',
            needsDeterministicSorting: true,
        },
        {
            field: 'endTimestamp',
            alias: 'End Date',
            shortName: 'End Date',
            type: 'TIMESTAMP',
            allowedOperators: 'ALL',
            format: 'ISO',
            needsDeterministicSorting: true,
        },
        {
            field: 'subscriptionType',
            alias: 'Subscription Type',
            shortName: 'Type',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                aap: [
                    { value: 'ORDER_PT_LOO', label: 'Portable Toilet' },
                    { value: 'ORDER_RO', label: 'Roll-Off' },
                    { value: 'ORDER_COMMERCIAL', label: 'Commercial' },
                ],
                wayste: [
                    { value: 'ORDER_PT_LOO', label: 'Portable Toilet' },
                    { value: 'ORDER_RO', label: 'Roll-Off' },
                    { value: 'ORDER_COMMERCIAL', label: 'Commercial' },
                ],
            },
        },
        {
            field: 'status',
            alias: 'Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: {
                aap: [
                    {
                        value: 'ACTIVE',
                        label: 'Active',
                    },
                    {
                        value: 'PAUSED',
                        label: 'Paused',
                    },
                    {
                        value: 'CANCELLED',
                        label: 'Canceled',
                    },
                ],
                wayste: [
                    {
                        value: 'ACTIVE',
                        label: 'Active',
                    },
                    {
                        value: 'PAUSED',
                        label: 'Paused',
                    },
                    {
                        value: 'CANCELLED',
                        label: 'Canceled',
                    },
                    {
                        value: 'SUSPENDED',
                        label: 'Suspended',
                    },
                    {
                        value: 'COMPLETE',
                        label: 'Complete',
                    },
                    {
                        value: 'DELETE',
                        label: 'Delete',
                    },
                ],
                'customer-portal': [
                    {
                        value: 'ACTIVE',
                        label: 'Active',
                    },
                    {
                        value: 'PAUSED',
                        label: 'Paused',
                    },
                    {
                        value: 'CANCELLED',
                        label: 'Canceled',
                    },
                ],
            },
            allowsMultipleValues: true,
        },
        {
            field: 'createdAt',
            type: 'TIMESTAMP',
            alias: 'Created At',
            shortName: 'Created',
            allowedOperators: 'ALL',
            format: 'ISO',
            disabledOn: ['wayste', 'customer-portal'],
        },
        {
            field: 'lastUpdatedAt',
            type: 'TIMESTAMP',
            alias: 'Last Updated At',
            shortName: 'Last Updated',
            allowedOperators: 'ALL',
            format: 'ISO',
            disabledOn: ['wayste', 'customer-portal'],
        },
    ],
    extraMappings: [],
};
//# sourceMappingURL=operations-subscription.js.map